import { SlotGameType1_2_2Screen } from "../SlotGameType1_2_2Screen";
import { Scale} from "../.././MyHelpers";
import { IReadOnlyResourceManager, ResourceManager } from "../../ResourceManager/ResourceManager";
import { FontResource } from "../../ResourceManager/FontResource";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { FreegameBonusFactory2_2screen , FreegameBonus2_2Screen } from "../FreegameBonus/FreegameBonus2_2Screen";
import { FreegamesCommonConfiguration } from "../../api";
import { FreegameBonus2Params } from "../FreegameBonus/FreegameBonus2";
import { SlideFactory } from "../Slider/SecondScreenHelp";

// namespace SlotGames2
// {
	export class FiestaEnchilada2_2Screen extends SlotGameType1_2_2Screen
	{
   
		// public PrepareFont(resourceManager: ResourceManager)
		// {
		// 	//resourceManager.Add(new FontResource(this.basepath + "resources/huggable.ttf", "." + this.resid.ScopedResourceName("font")));
		// 	resourceManager.Add(new FontResource(this.basepath + "resources/MexicanTequila.ttf", "." + this.resid.ScopedResourceName(["font"])));
		// 	resourceManager.Add(new FontResource(this.basepath + "resources/MexicanTequila.ttf",this.resid.ScopedResourceName(["BigSymbolFreegames2-font"])));
		// }
	//	protected freegameBonusFactory: FreegameBonusFactory2 = new AlChileFreegame2BonusFactory();
	
	protected freegameBonusFactory_2screen: FreegameBonusFactory2_2screen = new AlChileFreegame2BonusFactory_2Screen();

	protected override PaytableLoaded(resourceManager: IReadOnlyResourceManager): void 
	{
		

	}
	



	
}



class AlChile2Freegame_2Screen extends FreegameBonus2_2Screen 
{
	public override async PrepareFonts(resourceManager: ResourceManager)
	{
		//resourceManager.Add(new FontResource(this.basepath + "resources/huggable.ttf", "." + this.resid.ScopedResourceName("font")));
		resourceManager.Add(new FontResource(this.basepath + "resources/MexicanTequila.ttf", "." + this.resid.ScopedResourceName(["font"])));
	}
}





class AlChileFreegame2BonusFactory_2Screen extends FreegameBonusFactory2_2screen
{
	public override CreateFreegameBonus2_2Screen(gameName: ResourceIdentifier, freeGameConfig: FreegamesCommonConfiguration,  p: FreegameBonus2Params): FreegameBonus2_2Screen 
	{
		return new AlChile2Freegame_2Screen(gameName, freeGameConfig,  p);
	}
}

// }